<template>
  <div class="ocr-page">
    <v-img alt="Logo" class="shrink mr-2 app ocr-logo" contain :src="logoimage" transition="scale-transition" />

    <v-sheet class="folded-corner ocr-panel">
      <v-container>
        <v-card elevation="0" class="ocr-card align-center pa-4 mx-auto">
          <header class="ocr-header">
            <h1>{{ "กรุณาวางบัตรยืนยันตัวตนในกรอบ" }}</h1>
            <p>{{ "Place your ID card in the frame" }}</p>
            <span>{{ textAleart }}</span>
            <v-divider class="ocr-divider"></v-divider>
          </header>

          <div class="camera-stage">
            <div class="camera-container">
              <video v-show="!isPhotoTaken" ref="camera" autoplay playsinline muted></video>
              <div class="id-card-frame">
                <div class="id-card-chip"></div>
                <div class="id-card-lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div class="ocr-actions">
            <v-card elevation="0" class="box white--text text-capitalize ocr-button" color="#344054"
              @click="BackToMain()" style="line-height:1.1">
              <span>{{ "ย้อนกลับ" }}</span>
              <small>{{ "BACK" }}</small>
            </v-card>

            <v-card id="downloadPhoto" elevation="0" class="box white--text text-capitalize ocr-button"
              color="#344054" :download="PictureName" @click="takePhoto1()" style="line-height:1.1">
              <span>{{ "ถ่ายรูป" }}</span>
              <small>{{ "TAKE NOW" }}</small>
            </v-card>
          </div>
        </v-card>
      </v-container>
    </v-sheet>



    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <div class="loading-box">
        <div class="inter-load">
          <div class="rect rect1"></div>
          <div class="rect rect2"></div>
          <div class="rect rect3"></div>
          <div class="rect rect4"></div>
          <div class="rect rect5"></div>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="ocrRetryDialog" persistent max-width="620">
      <v-card class="ocr-retry-card">
        <h2>{{ "อ่านบัตรไม่สำเร็จ" }}</h2>
        <div v-if="ocrRetryImage" class="ocr-retry-image-wrap">
          <img :src="ocrRetryImage" alt="OCR submitted image" />
        </div>
        <p>{{ ocrRetryMessage }}</p>
        <v-btn class="ocr-retry-button" depressed @click="retryCapture">
          <span>{{ "ถ่ายใหม่" }}</span>
          <small>{{ "RETAKE" }}</small>
        </v-btn>
      </v-card>
    </v-dialog>


  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
// import logoimage from "@/assets/OneBangkokLogo.png";

// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "OCR",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      settingUrl: enurl.settingUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      isPhotoTaken: false,
      download: false,
      LoadingDialog: false,
      PictureName: "PersonID.jpg",
      dataParam: [],
      imageParam: "",
      photoBase64: "",
      logoimage: "",
      textAleart: "*วางบัตรให้อยู่ในกรอบ ระบบจะถ่ายอัตโนมัติ",
      imageCapture: null,
      autoCaptureEnabled: true,
      autoCaptureTimer: null,
      autoCaptureCanvas: null,
      isAutoCapturing: false,
      cardDetectedFrameCount: 0,
      lastAutoCaptureAt: 0,
      autoCaptureReadyAt: 0,
      baselineGray: null,
      ocrRetryDialog: false,
      ocrRetryMessage: "กรุณาวางบัตรให้อยู่ในกรอบ แล้วถ่ายใหม่อีกครั้ง",
      ocrRetryImage: "",
      count: 0,

      dataM: {
        documentNumber: "",
        prefixEN: "",
        firstnameEN: "Visitor",
        middlenameEN: "",
        lastnameEN: "Kiosk",
        sexEN: "",
        prefixTH: "",
        firstnameTH: "Visitor",
        middlenameTH: "",
        lastnameTH: "Kiosk",
        sexTH: "",
        type: "ID Card",
        image1: "",
        image2: "",
        tenantID: 0,
        towerID: 1,
        zoneID: 0,
        floorID: 0,
        locationID: 0,
      },

    };
  },

  mounted: function () {
    let self = this;


    // console.log(self.$route.params);
    self.dataParam = this.dataM;
    self.logoimage = require("@/assets/OneBangkokLogo.png");
    self.createCameraElement();
    // setInterval(() => {
    //   self.getCurrentDate();
    // }, 1000);
  },

  beforeDestroy() {
    this.stopAutoCapture();
    this.stopCameraStream();
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },



    stopCameraStream() {
      this.stopAutoCapture();

      if (this.$refs.camera && this.$refs.camera.srcObject != null) {
        let tracks = this.$refs.camera.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
        this.$refs.camera.srcObject = null;
      }


    },

    ocr() {
      let self = this;
      let temp = {
        image_data: this.dataParam.image1
      };
      axios
        .post(`${self.url}VMS/readOCR`, temp)
        .then(function (response) {

          if (response.status == 200) {

            if ((response.data.Englishname_firstname == null && response.data.Englishname_lastname == null) || response.data.Id == null ) {

              const apiMessage = self.getApiErrorMessage(response.data);
              self.handleOcrFailure("*กรุณาถ่ายบัตรอีกครั้ง", apiMessage);
              //  self.$router.push({
              //   name: "CapturePerson",
              //   path: "/CapturePerson",
              //   params: {
              //     data: self.dataParam,
              //   },
              // });
              self.count++;
              if (self.count == 3) {
                self.textAleart = "***กรุณาติดต่อพนักงาน***";

              }
            } else {

              
              response.data.Englishname_firstname = response.data.Englishname_firstname == null ? response.data.Englishname_firstname : response.data.Englishname_firstname.replace(/\s/g, '');
              response.data.Englishname_lastname = response.data.Englishname_lastname == null ? response.data.Englishname_lastname : response.data.Englishname_lastname.replace(/\s/g, '');
              response.data.Thainame_firstname = response.data.Thainame_firstname == null ? response.data.Thainame_firstname : response.data.Thainame_firstname.replace(/\s/g, '');
              response.data.Thainame_lastname = response.data.Thainame_lastname == null ? response.data.Thainame_lastname : response.data.Thainame_lastname.replace(/\s/g, '');


              self.dataParam.documentNumber = response.data.Id == null ? self.dataParam.documentNumber : response.data.Id;
              self.dataParam.firstnameEN = response.data.Englishname_firstname == null ? self.dataParam.firstnameEN : response.data.Englishname_firstname;
              self.dataParam.lastnameEN = response.data.Englishname_lastname == null ? self.dataParam.lastnameEN : response.data.Englishname_lastname;
              self.dataParam.firstnameTH = response.data.Thainame_firstname == null ? self.dataParam.firstnameTH : response.data.Thainame_firstname;
              self.dataParam.lastnameTH = response.data.Thainame_lastname == null ? self.dataParam.lastnameTH : response.data.Thainame_lastname;




              self.$router.push({
                name: "CapturePerson",
                path: "/CapturePerson",
                params: {
                  data: self.dataParam,
                },
              });
            }
            self.LoadingDialog = false;
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
          const apiMessage = self.getApiErrorMessage(error);
          const message =
            error && error.response && error.response.status === 400
              ? "*อ่านข้อมูลบัตรไม่สำเร็จ กรุณาถ่ายใหม่"
              : "*OCR มีปัญหา กรุณาถ่ายใหม่อีกครั้ง";
          self.handleOcrFailure(message, apiMessage);
        });
    },

    getApiErrorMessage(error) {
      if (!error) {
        return "";
      }

      const payload = error.response && error.response.data ? error.response.data : error;

      if (typeof payload === "string") {
        return payload;
      }

      const message =
        payload.message ||
        payload.Message ||
        payload.error ||
        payload.Error ||
        payload.detail ||
        payload.Detail ||
        payload.title ||
        payload.Title;

      if (typeof message === "string") {
        return message;
      }

      if (Array.isArray(message)) {
        return message.join(", ");
      }

      if (payload.errors || payload.Errors) {
        const errors = payload.errors || payload.Errors;
        if (Array.isArray(errors)) {
          return errors.join(", ");
        }

        if (typeof errors === "object") {
          return Object.values(errors)
            .reduce((list, value) => list.concat(value), [])
            .filter(Boolean)
            .join(", ");
        }
      }

      return "";
    },

    createCameraElement() {
      const constraints = (window.constraints = {
        audio: false,
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.$refs.camera.srcObject = stream;
          const track = stream.getVideoTracks()[0];
          this.applyCameraFocus(track);

          if ("ImageCapture" in window) {
            this.imageCapture = new ImageCapture(track);
          }
          this.$refs.camera.onloadedmetadata = () => {
            this.prepareAutoCaptureBaseline();
            this.startAutoCapture();
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    applyCameraFocus(track) {
      if (!track || !track.getCapabilities) {
        return;
      }

      const capabilities = track.getCapabilities();
      let focusSettings = null;

      if (capabilities.focusMode && capabilities.focusMode.includes("continuous")) {
        focusSettings = { focusMode: "continuous" };
      } else if (capabilities.focusMode && capabilities.focusMode.includes("manual")) {
        focusSettings = { focusMode: "manual" };
      }

      if (focusSettings && focusSettings.focusMode === "manual" && capabilities.focusDistance) {
        const minDistance = capabilities.focusDistance.min || 0;
        const nearDistance = Math.max(minDistance, 0.05);
        focusSettings.focusDistance = nearDistance;
      }

      if (focusSettings) {
        track.applyConstraints({ advanced: [focusSettings] }).catch(() => {});
      }
    },

    restartCameraStream() {
      this.stopCameraStream();
      this.imageCapture = null;
      this.$nextTick(() => {
        this.createCameraElement();
      });
    },

    handleOcrFailure(message, apiMessage = "") {
      const submittedImage = this.photoBase64 || (this.dataParam.image1 ? `data:image/jpeg;base64,${this.dataParam.image1}` : "");
      this.LoadingDialog = false;
      this.isPhotoTaken = false;
      this.isAutoCapturing = false;
      this.imageParam = "";
      this.photoBase64 = "";
      this.dataParam.image1 = "";
      this.textAleart = message;
      this.ocrRetryMessage = apiMessage
        ? `${apiMessage} กรุณาวางบัตรให้อยู่ในกรอบ ตรวจให้ชัด แล้วกดถ่ายใหม่`
        : "กรุณาวางบัตรให้อยู่ในกรอบ ตรวจให้ชัด แล้วกดถ่ายใหม่";
      this.ocrRetryImage = submittedImage;
      this.ocrRetryDialog = true;
      this.stopAutoCapture();
      this.restartCameraStream();
    },

    retryCapture() {
      this.ocrRetryDialog = false;
      this.ocrRetryImage = "";
      this.resetAutoCaptureState();
      this.textAleart = "*วางบัตรให้อยู่ในกรอบ ระบบจะถ่ายอัตโนมัติ";

      if (!this.$refs.camera || !this.$refs.camera.srcObject) {
        this.restartCameraStream();
        return;
      }

      this.startAutoCapture();
    },

    async takePhoto1(fromAuto = false) {
      let self = this;
      if (self.LoadingDialog || (self.isAutoCapturing && !fromAuto)) {
        return;
      }

      self.stopAutoCapture(false);
      self.isAutoCapturing = true;
      self.LoadingDialog = true;
      self.textAleart = "*กำลังถ่ายและอ่านข้อมูล กรุณารอสักครู่";

      try {
        const base64 = await this.captureCardBase64();

        this.isPhotoTaken = true;
        this.photoBase64 = base64;
        this.dataParam.image1 = base64.split(",")[1];
        this.ocr();
      } catch (error) {
        console.log(error);
        self.LoadingDialog = false;
        self.textAleart = "*ไม่สามารถถ่ายรูปได้ กรุณาลองอีกครั้ง";
        self.resetAutoCaptureState();
        self.startAutoCapture();
      }
    },

    async captureCardBase64() {
      if (this.imageCapture && this.imageCapture.takePhoto) {
        const blob = await this.imageCapture.takePhoto();
        return this.cropAndConvertToBase64(blob, 900, 900);
      }

      const video = this.$refs.camera;
      if (!video || !video.videoWidth || !video.videoHeight) {
        throw new Error("Camera is not ready");
      }

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL("image/jpeg", 0.86);
    },

    async cropAndConvertToBase64(blob, cropTop = 0, cropBottom = 0) {
      const imageBitmap = await createImageBitmap(blob);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // คำนวณขนาดภาพที่เหลือหลังตัด
      const safeCropTop = Math.min(cropTop, Math.floor(imageBitmap.height * 0.25));
      const safeCropBottom = Math.min(cropBottom, Math.floor(imageBitmap.height * 0.25));
      const cropHeight = imageBitmap.height - safeCropTop - safeCropBottom;

      // ตั้งขนาด canvas ใหม่
      canvas.width = imageBitmap.width;
      canvas.height = cropHeight;

      // วาดภาพเฉพาะส่วนที่ต้องการ (เริ่มจาก cropTop ลงมา)
      ctx.drawImage(
        imageBitmap,
        0, safeCropTop, imageBitmap.width, cropHeight, // ส่วนที่ตัดจากต้นฉบับ
        0, 0, imageBitmap.width, cropHeight        // วาดลงบน canvas
      );

      // แปลง canvas → base64
      return canvas.toDataURL("image/jpeg", 0.8); // 0.9 = คุณภาพ
    },

    startAutoCapture() {
      if (this.ocrRetryDialog || !this.autoCaptureEnabled || this.autoCaptureTimer || this.LoadingDialog) {
        return;
      }

      this.autoCaptureTimer = setInterval(() => {
        this.scanAutoCapture();
      }, 200);
    },

    stopAutoCapture(clearState = true) {
      if (this.autoCaptureTimer) {
        clearInterval(this.autoCaptureTimer);
        this.autoCaptureTimer = null;
      }

      if (clearState) {
        this.resetAutoCaptureState();
      }
    },

    resetAutoCaptureState() {
      this.isAutoCapturing = false;
      this.cardDetectedFrameCount = 0;
    },

    prepareAutoCaptureBaseline() {
      this.baselineGray = null;
      this.cardDetectedFrameCount = 0;
      this.autoCaptureReadyAt = Date.now() + 1200;
      this.textAleart = "*เตรียมกล้อง กรุณาวางบัตรให้อยู่ในกรอบ";
    },

    scanAutoCapture() {
      if (this.LoadingDialog || this.isPhotoTaken || this.isAutoCapturing) {
        return;
      }

      if (Date.now() < this.autoCaptureReadyAt) {
        return;
      }

      if (Date.now() - this.lastAutoCaptureAt < 1800) {
        return;
      }

      const metrics = this.getCameraFrameMetrics();
      if (!metrics) {
        return;
      }

      if (!this.baselineGray) {
        this.baselineGray = metrics.gray;
        this.textAleart = "*วางบัตรให้อยู่ในกรอบ ระบบจะถ่ายอัตโนมัติ";
        return;
      }

      const frameChangeScore = this.getFrameChangeScore(metrics.gray, this.baselineGray);

      const hasCardDetail =
        metrics.contrast > 28 &&
        metrics.edgeScore > 9.5 &&
        metrics.brightness > 95 &&
        metrics.brightness < 235 &&
        metrics.lightPixelRatio > 0.32 &&
        metrics.lightPixelRatio < 0.92 &&
        frameChangeScore > 20;

      if (hasCardDetail) {
        this.cardDetectedFrameCount++;
        this.textAleart = "*พบบัตรแล้ว กำลังถ่ายอัตโนมัติ";

        if (this.cardDetectedFrameCount >= 2) {
          this.lastAutoCaptureAt = Date.now();
          this.takePhoto1(true);
        }
      } else {
        this.cardDetectedFrameCount = 0;
        this.textAleart = "*วางบัตรให้อยู่ในกรอบ ระบบจะถ่ายอัตโนมัติ";
      }
    },

    getFrameChangeScore(currentGray, baselineGray) {
      if (!currentGray || !baselineGray || currentGray.length !== baselineGray.length) {
        return 0;
      }

      let diff = 0;
      for (let i = 0; i < currentGray.length; i += 3) {
        diff += Math.abs(currentGray[i] - baselineGray[i]);
      }

      return diff / Math.ceil(currentGray.length / 3);
    },

    getCameraFrameMetrics() {
      const video = this.$refs.camera;
      if (!video || video.readyState < 2 || !video.videoWidth || !video.videoHeight) {
        return null;
      }

      const sampleWidth = 120;
      const sampleHeight = 80;
      const sourceWidth = video.videoWidth * 0.72;
      const sourceHeight = video.videoHeight * 0.76;
      const sourceX = (video.videoWidth - sourceWidth) / 2;
      const sourceY = (video.videoHeight - sourceHeight) / 2;

      if (!this.autoCaptureCanvas) {
        this.autoCaptureCanvas = document.createElement("canvas");
        this.autoCaptureCanvas.width = sampleWidth;
        this.autoCaptureCanvas.height = sampleHeight;
      }

      const canvas = this.autoCaptureCanvas;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx.drawImage(video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, sampleWidth, sampleHeight);

      const pixels = ctx.getImageData(0, 0, sampleWidth, sampleHeight).data;
      const gray = new Uint8Array(sampleWidth * sampleHeight);
      let sum = 0;
      let min = 255;
      let max = 0;
      let edgeTotal = 0;
      let edgeSamples = 0;
      let lightPixels = 0;

      for (let i = 0, j = 0; i < pixels.length; i += 4, j++) {
        const value = Math.round(pixels[i] * 0.299 + pixels[i + 1] * 0.587 + pixels[i + 2] * 0.114);
        gray[j] = value;
        sum += value;
        min = Math.min(min, value);
        max = Math.max(max, value);
        if (value > 145) {
          lightPixels++;
        }
      }

      for (let y = 1; y < sampleHeight; y += 2) {
        for (let x = 1; x < sampleWidth; x += 2) {
          const index = y * sampleWidth + x;
          edgeTotal +=
            Math.abs(gray[index] - gray[index - 1]) +
            Math.abs(gray[index] - gray[index - sampleWidth]);
          edgeSamples += 2;
        }
      }

      return {
        brightness: sum / gray.length,
        contrast: max - min,
        edgeScore: edgeTotal / edgeSamples,
        lightPixelRatio: lightPixels / gray.length,
        gray,
      };
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // ผลลัพธ์จะเป็น Base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    takePhoto() {
      let self = this;
      self.isShotPhoto = true;
      self.LoadingDialog = true;
      const FLASH_TIMEOUT = 50;


      const videoElement = self.$refs.camera;
      const canvasElement = self.$refs.canvas;
      const context = canvasElement.getContext("2d");

      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;
      context.drawImage(
        videoElement,
        -180, -650,
        1080,
        1980
      );

      setTimeout(() => {
        self.isShotPhoto = false;
        self.GotoFindingTenant();
        // this.downloadImage();
      }, FLASH_TIMEOUT);

    },

    downloadImage() {
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      if (canvas) {
        canvas.focus();
      }
      this.isPhotoTaken = true;
      this.imageParam = canvas;
      this.dataParam.image1 = this.imageParam.split(",")[1];
      // this.ocr();

    },

    GotoFindingTenant() {
      let self = this;
      self.downloadImage();
      self.stopCameraStream();
      // self.$router.push("/FindingTenant");


      // self.$router.push({
      //   name: "CapturePerson",
      //   path: "/CapturePerson",
      //   params: {
      //     data: self.dataParam,
      //   },
      // });

    },

    BackToMain() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    BacktoNationalIDCard() {
      let self = this;
      self.stopCameraStream();
      self.$router.push("/NationalIDCard");
    },

    CapturePerson() {
      let self = this;
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
.ocr-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(14px, 2vh, 24px);
  padding: clamp(18px, 3vw, 40px);
}

.ocr-page .ocr-logo {
  width: min(28vw, 430px) !important;
  max-width: min(28vw, 430px) !important;
  margin: 0 !important;
}

.ocr-page .ocr-panel {
  width: min(1060px, calc(100vw - 160px)) !important;
  min-height: 0 !important;
  max-height: calc(100vh - 160px);
  margin: 0 auto !important;
  padding: clamp(18px, 2.4vw, 34px) !important;
}

.ocr-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(14px, 2vh, 22px);
}

.ocr-header {
  text-align: center;
}

.ocr-header h1 {
  color: #344054;
  font-size: clamp(34px, 3.2vw, 56px);
  font-weight: 800;
  line-height: 1.1;
  margin: 0;
}

.ocr-header p {
  color: #667085;
  font-size: clamp(22px, 2vw, 34px);
  font-weight: 700;
  line-height: 1.2;
  margin: 8px 0 0;
}

.ocr-header span {
  display: block;
  color: #e11d48;
  font-size: clamp(16px, 1.1vw, 20px);
  font-weight: 800;
  margin-top: 14px;
}

.ocr-divider {
  width: min(520px, 44vw);
  margin: 14px auto 0;
  border-top-width: 7px !important;
  border-color: #344054 !important;
}

.camera-stage {
  display: flex;
  justify-content: center;
  width: 100%;
}

.ocr-page .camera-container {
  width: min(48vw, 650px) !important;
  height: min(34vh, 360px) !important;
  min-height: 280px;
}

.ocr-page video {
  width: 100% !important;
  height: 100% !important;
}

.ocr-actions {
  width: min(760px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: clamp(22px, 4vw, 56px);
}

.ocr-button {
  width: 100% !important;
  min-height: 86px !important;
  background-color: #344054 !important;
}

.ocr-button span {
  font-size: clamp(30px, 2.8vw, 44px);
  font-weight: 800;
}

.ocr-button small {
  font-size: clamp(16px, 1.3vw, 24px);
  font-weight: 700;
}

.ocr-retry-card {
  padding: 34px 32px 30px;
  text-align: center;
  border-radius: 22px !important;
  background: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 26px 70px rgba(16, 24, 40, 0.24) !important;
}

.ocr-retry-card h2 {
  margin: 0;
  color: #101828;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.15;
}

.ocr-retry-image-wrap {
  width: 100%;
  max-height: 260px;
  margin: 18px 0 16px;
  padding: 10px;
  border: 1px solid rgba(52, 64, 84, 0.18);
  border-radius: 14px;
  background: #f8fafc;
  overflow: hidden;
}

.ocr-retry-image-wrap img {
  display: block;
  width: 100%;
  max-height: 238px;
  object-fit: contain;
  border-radius: 10px;
}

.ocr-retry-card p {
  margin: 14px 0 26px;
  color: #475467;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.35;
}

.ocr-retry-button {
  width: 100%;
  min-height: 78px !important;
  border-radius: 999px !important;
  color: #ffffff !important;
  background:
    linear-gradient(115deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0) 38%),
    linear-gradient(180deg, #475467 0%, #1d2939 100%) !important;
  box-shadow:
    inset 0 2px 0 rgba(255, 255, 255, 0.24),
    inset 0 -4px 8px rgba(0, 0, 0, 0.22),
    0 18px 32px rgba(16, 24, 40, 0.26) !important;
}

.ocr-retry-button span,
.ocr-retry-button small {
  display: block;
  color: #ffffff;
  line-height: 1.05;
  text-shadow: 0 2px 3px rgba(0, 0, 0, 0.28);
}

.ocr-retry-button span {
  font-size: 30px;
  font-weight: 800;
}

.ocr-retry-button small {
  font-size: 16px;
  font-weight: 800;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}

.camera-container {
  position: relative;
  width: 640px;
  height: 480px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.overlay-hole {
  /* ทำให้ครอบคลุมทั้งหน้าจอและอยู่เหนือองค์ประกอบอื่น */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  
  /* ให้มีสีพื้นหลังที่ต้องการจะบัง (เช่น สีดำโปร่งใส) */
  background-color: rgba(0, 0, 0, 0.6); /* 60% ความทึบ */
  
  /* เปิดใช้งานการตัดของ overlay */
  pointer-events: none;
  
  /* ใช้ Mask/Clip-path เพื่อตัด "รู" */
  /* ตำแหน่งของรู: 15% จากซ้าย, 15% จากบน, กว้าง 70%, สูง 70% */
  -webkit-mask: 
      /* ส่วนที่มองเห็นทะลุ: สี่เหลี่ยมโปร่งใส */
      radial-gradient(
          circle at 50% 50%, 
          transparent 0, 
          transparent 35vh, 
          black 35vh
      );
  mask: 
      /* ส่วนที่มองเห็นทะลุ: สี่เหลี่ยมโปร่งใส */
      radial-gradient(
          circle at 50% 50%, 
          transparent 0, 
          transparent 35vh, 
          black 35vh
      );
  
  /* ใช้ border-radius และตำแหน่งที่คุณกำหนดไว้ (เป็นเพียงกรอบแสดงตำแหน่ง) */
  /* คุณอาจไม่จำเป็นต้องใช้โค้ดนี้หากใช้ .overlay-hole */
  /* แต่นี่คือวิธีที่ใช้ box-shadow เพื่อสร้าง "รู" */
  /* ****************************************************** */
  
  /* วิธีที่ง่ายกว่าคือใช้ box-shadow กับ pseudo-element */
  /* ยกเลิก mask/clip-path ด้านบน แล้วใช้โค้ดด้านล่างแทน */
}

/* === Overlay สี่เหลี่ยมเต็ม (ถ่ายบัตรประชาชน) === */
.overlay-full {
  position: absolute;
  top: 15%;
  left: 15%;
  width: 70%;
  height: 70%;
  border: 20px solid #787c78;
  border-radius: 10px;
  pointer-events: none;
}


.overlay-full::before {
  /* ใช้โค้ดนี้กับ overlay-full เดิม */
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: auto; 
  z-index: 5;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6); 
  
  /* ทำให้เงาอยู่ใต้กรอบ border */
  mix-blend-mode: multiply;
}

.id-card-frame {
  position: absolute;
  top: 12%;
  left: 14%;
  width: 72%;
  height: 76%;
  pointer-events: none;
  border: 5px solid rgba(255, 255, 255, 0.94);
  border-radius: 18px;
  box-shadow:
    0 0 0 9999px rgba(16, 24, 40, 0.18),
    inset 0 0 0 2px rgba(52, 64, 84, 0.32),
    0 16px 34px rgba(16, 24, 40, 0.22);
}

.id-card-frame::before {
  content: "";
  position: absolute;
  inset: 12px;
  border: 2px dashed rgba(255, 255, 255, 0.72);
  border-radius: 12px;
}

.id-card-frame::after {
  content: "ID CARD";
  position: absolute;
  right: 18px;
  bottom: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(14px, 1.2vw, 20px);
  font-weight: 900;
  letter-spacing: 0;
  text-shadow: 0 2px 5px rgba(16, 24, 40, 0.36);
}

.id-card-chip {
  position: absolute;
  top: 22%;
  left: 9%;
  width: 16%;
  height: 18%;
  border: 3px solid rgba(255, 255, 255, 0.86);
  border-radius: 8px;
  box-shadow: inset 0 0 0 2px rgba(52, 64, 84, 0.2);
}

.id-card-lines {
  position: absolute;
  top: 28%;
  left: 34%;
  width: 48%;
  display: grid;
  gap: 9px;
}

.id-card-lines span {
  display: block;
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.18);
}

.id-card-lines span:nth-child(2) {
  width: 84%;
}

.id-card-lines span:nth-child(3) {
  width: 62%;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 60px;
  aspect-ratio: .5;
  display: grid;
}

.loader:before {
  content: "";
  width: 30%;
  aspect-ratio: 1;
  border-radius: 50%;
  margin: auto auto 0;
  background: #CF4647;
  animation: l9-0 .5s cubic-bezier(0, 800, 1, 800) infinite;
}

.loader:after {
  content: "";
  width: 100%;
  aspect-ratio: 1/cos(30deg);
  margin: 0 auto auto;
  clip-path: polygon(50% -50%, 100% 50%, 50% 150%, 0 50%);
  background: #524656;
  animation: l9-1 .5s linear infinite;
}

@keyframes l9-0 {

  0%,
  2% {
    translate: 0 0%
  }

  98%,
  to {
    translate: 0 -.2%
  }
}

@keyframes l9-1 {

  0%,
  5% {
    rotate: 0deg
  }

  95%,
  to {
    rotate: -60deg
  }
}
</style>
